import { css } from '@emotion/core'
import { Flow, Heading, Icon, Tag, Theme, useTheme } from 'bold-ui'
import { AccordionButton } from 'components/accordion/AccordionButton'
import React, { ReactNode } from 'react'
import { AccordionItem, AccordionItemPanel } from 'react-accessible-accordion'

interface AcompanhamentoCondicaoSaudeFiltrosAvancadosAccordionItemProps {
  uuid: string
  title: string
  isNovo?: boolean
  children: ReactNode
}

export const AcompanhamentoCondicaoSaudeFiltrosAvancadosAccordionItem = (
  props: AcompanhamentoCondicaoSaudeFiltrosAvancadosAccordionItemProps
) => {
  const { uuid, title, isNovo, children } = props

  const theme = useTheme()
  const accordionItemStyles = createAccordionItemStyles(theme)

  return (
    <AccordionItem uuid={uuid}>
      <AccordionButton wrapperStyle={accordionItemStyles.buttonWrapper} style={accordionItemStyles.button}>
        <Flow direction='horizontal' alignItems='center' justifyContent='space-between'>
          <Flow direction='horizontal' gap={0.5} alignItems='center'>
            <Heading level={3}>{title}</Heading>
            {isNovo && <Tag type='info'>Novo</Tag>}
          </Flow>
          <Icon icon='angleDown' />
        </Flow>
      </AccordionButton>
      <AccordionItemPanel css={accordionItemStyles.panel}>{children}</AccordionItemPanel>
    </AccordionItem>
  )
}

const createAccordionItemStyles = (theme: Theme) => ({
  buttonWrapper: css`
    padding-bottom: 0;
  `,
  button: css`
    padding: 1rem 0.2rem;
    border-bottom: 1px solid ${theme.pallete.divider};

    &[aria-expanded='true'] {
      border-bottom: none;
      padding-bottom: 0.3rem;
      margin-bottom: 0;
    }
  `,
  panel: css`
    margin: 0 0.3rem;
    padding: 0.5rem 0.2rem 1rem;
    border-bottom: 1px solid ${theme.pallete.divider};
  `,
})
